var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tag",class:_vm.due.css},[_vm._m(0),_c('span',[_vm._v(_vm._s(_vm.due.text))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"mdi mdi-clock-outline"})])
}]

export { render, staticRenderFns }